<script lang="ts">
  import type { Snippet } from 'svelte';
  import { user, authReady } from '../lib/stores/auth';
  import Navigate from './Navigate.svelte';
  import Spinner from './ui/Spinner.svelte';

  // Mirror of RequireAuth: routes that only make sense for signed-out
  // users (login, register, OAuth finish). If a user is already signed
  // in, send them to ?next= if present, else /account.
  //
  // Why /account and not /: feels weird to send a logged-in user back to
  // the homepage when they explicitly typed /login — clearly they were
  // looking for account UI. /account also gives them a place to sign out.

  interface Props {
    /** Override the default redirect for already-authed users. */
    redirectTo?: string;
    children: Snippet;
  }

  let { redirectTo = '/account', children }: Props = $props();

  const nextDestination = $derived.by(() => {
    if (typeof window === 'undefined') return redirectTo;
    const next = new URL(window.location.href).searchParams.get('next');
    if (next && next.startsWith('/')) return next;
    return redirectTo;
  });
</script>

{#if !$authReady}
  <div class="page-center"><Spinner size="lg" /></div>
{:else if $user}
  <Navigate to={nextDestination} replace />
{:else}
  {@render children()}
{/if}
